import React from "react";
import CustomBreadcrumbs, { BreadcrumbItem } from "../../../component/CustomBreadcrumbs";
import { CreateButton, Datagrid, FunctionField, List, ReferenceField, TextField } from "react-admin";
import Box from "@mui/material/Box";
import { Card, CardContent, CardHeader, Divider, Stack } from "@mui/material";
import CustomShowButton from "../../../component/CustomShowButton";
import CustomEditButton from "../../../component/CustomEditButton";
import CustomDeleteIconButton from "../../../component/CustomDeleteIconButton";

const ProductGroupList = () => {

    const productGroupListBreadcrumbItems: BreadcrumbItem[] = [
        {
            label: 'Product Groups',
            isCurrent: true,
        },
    ];

    return (
        <List
            actions={false}
            exporter={false}
            sort={{ field: 'recordId', order: 'ASC' }}
            perPage={25}
            empty={false}
            component="div"
            title="Product Group Management"
        >
            <Box>
                <CustomBreadcrumbs title={"Product Group Management"} items={productGroupListBreadcrumbItems} />
                <Card>
                    <CardHeader title="Product Groups" action={<CreateButton />} />
                    <Divider />
                    <CardContent>
                        <Datagrid bulkActionButtons={false}>
                            <FunctionField label="Actions" render={() => (
                                <Stack direction="row" spacing={1}>
                                    <CustomShowButton />
                                    <CustomEditButton />
                                    <CustomDeleteIconButton />
                                </Stack>
                            )}/>
                            <TextField source="recordId" />
                            <TextField source="name" />
                            <TextField source="description" />
                            <ReferenceField sortable={false} reference="productGroup" source="parentId" link="show">
                                <TextField source="name" />
                            </ReferenceField>
                        </Datagrid>
                    </CardContent>
                </Card>
            </Box>
        </List>
    );

}

export default ProductGroupList;
